<a [href]="url" (click)="navigatePlayer()">{{linkText || player.name}}</a>
